import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2, MessageCircle, Mail, Phone, X } from "lucide-react";
import { api } from "../../lib/api";

const STATUS = [
  { value: "new", label: "Yeni Talep" },
  { value: "contacted", label: "Görüşülüyor" },
  { value: "quoted", label: "Teklif Gönderildi" },
  { value: "approved", label: "Onaylandı" },
  { value: "rejected", label: "Reddedildi" },
  { value: "done", label: "Tamamlandı" },
];

export default function AdminMessages() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(null);

  const load = () => api.get("/admin/messages").then((r) => setItems(r.data));

  useEffect(() => { load(); }, []);

  const update = async (id, patch) => {
    try {
      await api.put(`/admin/messages/${id}`, patch);
      load();
    } catch { toast.error("Güncellenemedi"); }
  };

  const del = async (id) => {
    if (!window.confirm("Silmek istediğine emin misin?")) return;
    await api.delete(`/admin/messages/${id}`);
    toast.success("Silindi");
    load();
  };

  return (
    <div>
      <h1 className="font-display text-4xl uppercase tracking-tight text-white mb-2">Mesajlar</h1>
      <p className="text-white/50 text-sm mb-8">Gelen teklif talepleri</p>

      <div className="rounded-xl border border-white/5 bg-[#101018] overflow-hidden">
        <table className="w-full text-sm">
          <thead className="border-b border-white/5">
            <tr className="text-white/50 text-[10px] uppercase tracking-widest">
              <th className="text-left px-4 py-3">Kişi</th>
              <th className="text-left px-4 py-3">Firma</th>
              <th className="text-left px-4 py-3">İletişim</th>
              <th className="text-left px-4 py-3">Durum</th>
              <th className="text-left px-4 py-3">Tarih</th>
              <th className="text-right px-4 py-3">İşlem</th>
            </tr>
          </thead>
          <tbody>
            {items.length === 0 && (
              <tr><td colSpan={6} className="text-center text-white/40 py-10">Henüz mesaj yok.</td></tr>
            )}
            {items.map((m) => (
              <tr key={m.id} data-testid={`msg-${m.id}`} className={`border-b border-white/5 ${!m.read ? "bg-[#A855F7]/[0.05]" : ""}`}>
                <td className="px-4 py-3">
                  <button className="text-white hover:text-[#A855F7]" onClick={() => { setOpen(m); if (!m.read) update(m.id, { read: true }); }}>
                    {m.name}
                  </button>
                </td>
                <td className="px-4 py-3 text-white/70">{m.company || "—"}</td>
                <td className="px-4 py-3 text-white/70">{m.phone}<br /><span className="text-xs">{m.email}</span></td>
                <td className="px-4 py-3">
                  <select value={m.status} onChange={(e) => update(m.id, { status: e.target.value })} className="bg-[#0A0A11] border border-white/10 rounded px-2 py-1 text-white text-xs">
                    {STATUS.map((s) => <option key={s.value} value={s.value}>{s.label}</option>)}
                  </select>
                </td>
                <td className="px-4 py-3 text-white/50 text-xs">{m.created_at?.slice(0, 10)}</td>
                <td className="px-4 py-3 text-right">
                  <a href={`https://wa.me/${m.phone.replace(/[^0-9]/g, "")}`} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-green-400 hover:text-green-300 px-2 py-1 text-xs">
                    <MessageCircle size={12} />
                  </a>
                  <button onClick={() => del(m.id)} className="inline-flex items-center gap-1 text-red-400 hover:text-red-300 px-2 py-1 text-xs">
                    <Trash2 size={12} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {open && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80" onClick={() => setOpen(null)}>
          <div className="w-full max-w-xl rounded-2xl border border-white/10 bg-[#101018] p-8" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between mb-4">
              <h2 className="font-display text-2xl uppercase text-white">{open.name}</h2>
              <button onClick={() => setOpen(null)}><X size={18} className="text-white/50" /></button>
            </div>
            <div className="grid grid-cols-2 gap-4 text-sm mb-6">
              <div><span className="text-white/40 text-xs uppercase tracking-widest">Firma:</span><br />{open.company || "—"}</div>
              <div><span className="text-white/40 text-xs uppercase tracking-widest">Hizmet:</span><br />{open.service || "—"}</div>
              <div><Phone size={12} className="inline mr-1" />{open.phone}</div>
              <div><Mail size={12} className="inline mr-1" />{open.email}</div>
              <div><span className="text-white/40 text-xs uppercase tracking-widest">Bütçe:</span><br />{open.budget || "—"}</div>
              <div><span className="text-white/40 text-xs uppercase tracking-widest">Tarih:</span><br />{open.created_at?.slice(0, 16).replace("T", " ")}</div>
            </div>
            <div className="border border-white/10 rounded-lg p-4 text-white/80 whitespace-pre-wrap">
              {open.message}
            </div>
            <textarea
              placeholder="Not..."
              defaultValue={open.note || ""}
              onBlur={(e) => update(open.id, { note: e.target.value })}
              className="mt-4 w-full bg-[#0A0A11] border border-white/10 rounded-lg px-3 py-2 text-white text-sm focus:outline-none focus:border-[#A855F7]"
              rows={3}
            />
          </div>
        </div>
      )}
    </div>
  );
}
